<template>
  <div id="layout-default">
    <TopBar/>
    <div class="page-content">
      <router-view />
    </div>
    <Footer/>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import TopBar from '@/components/TopBar.vue';
import Footer from '@/components/Footer.vue';

export default {
  name: 'layout-default',
  components: {
    TopBar,
    Footer,
  },
  created() {
    const { subscribeViewport, subscribeWindowScroll } = this;
    subscribeViewport();
    subscribeWindowScroll();
  },
  computed: {
    ...mapState('viewport', ['viewport']),
  },
  methods: {
    ...mapActions('viewport', ['subscribeViewport', 'subscribeWindowScroll']),
  },
};
</script>
<style lang="stylus">
  @import '../styles/variables';

  #layout-default {
    position: relative;
    overflow-x: hidden;
  }
</style>
